<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
      <div class>
        <a-form :form="form" @submit="handleSubmit">
         <a-form-item label="上级分类" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-cascader
              placeholder="请选择"
              :options="treeData"
              changeOnSelect
              @change="treeChange"
              allowClear
              v-decorator="[
          'parentid',
          {rules: [{ required: true, message: '请选择上级分类!' }],initialValue:info.parentid}
        ]"
              :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
            />
          </a-form-item>
          <a-form-item label="类型名称" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入类型名称"
              v-decorator="[
          'name',
          {rules: [{ required: true, message: '请输入类型名称!' }],initialValue:info.name}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="备注" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-textarea placeholder="请输入备注" v-model="info.description" :rows="4" />
          </a-form-item>
           <a-form-item label="在导航显示" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-switch
            v-model="info.showOnPath"
              v-decorator="[
              'showOnPath',
              {rules: [],initialValue:info.showOnPath}
            ]"
            />
          </a-form-item>
<!--            <a-form-item  v-if="info.showOnPath" label="跳转链接" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">-->
<!--                <a-select v-model="info.category"  placeholder="请选择" style="width: 100px" allowClear>-->
<!--                    <a-select-option value="1">新闻列表</a-select-option>-->
<!--                    <a-select-option value="2">新闻详情</a-select-option>-->
<!--                    <a-select-option value="3">跳转其他页面</a-select-option>-->
<!--                </a-select>-->
<!--                            <a-input-->
<!--                              v-if="info.category==3"-->
<!--                                    placeholder="跳转链接"-->
<!--                                    v-decorator="[-->
<!--                          'linkurl',-->
<!--                          {rules: [{ required: false, message: '其他页面' }],initialValue:info.linkurl}-->
<!--                        ]"-->
<!--                            ></a-input>-->
<!--            </a-form-item>-->
          <a-form-item label="状态" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-switch
              v-model="info.status"
              v-decorator="[
          'status',
          {rules: []}
        ]"
            />
          </a-form-item>

          <a-form-item label="封面图" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-upload
              :action="$api.file.uploadFile"
              listType="picture-card"
              :fileList="fileList"
              @preview="handlePreview"
              @change="handleImgChange"
            >
              <div v-if="fileList.length < 8">
                <a-icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </a-upload>
            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 19, offset: 4 }">
            <pxkeji-btn name="保存" type="primary" htmlType="submit" />
            <pxkeji-btn name="取消" type="default" @click="cancelClick" class="cancelBtn" />
          </a-form-item>
        </a-form>
      </div>
    </div>
  </a-spin>
</template>

<script>
var that;
var thisInfo = [];

export default {
  props: {
    infos: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      info: {
        status: true
      },
      isloading: false,
      loadingTip: "加载中...",
      previewVisible: false,
      previewImage: "",
      fileList: [],
      treeData: [],
      uploadImg: [],
      alllist:[],

    };
  },
  mounted() {
    this.$nextTick(function() {
      that = this;
      this.getTree();
    });
  },

  methods: {
    /**取消 */
    cancelClick() {
      this.$emit("callbackMethod");
    },
    treeChange(val) {
      this.info.parentid = val;
    },
      linkchange(val) {
          this.info.linkurl = val;
      },
    buildTree(all,parentid){
        var list=[];
        for(var i=0;i<all.length;++i){
          var item=all[i];
          if(this.infos.id>0 && item.id==this.infos.id){
              continue;
          }
          if(item.parentid==parentid){
            var childs=this.buildTree(all,item.id);
            list.push({
                name: item.name,
                parentid: parentid,
                id: item.id,
                children: childs
            });
          }
        }
        return list;
    },
    getTree() {
      this.$api.articlecategory
        .getAll(this.id)
        .then(res => {
          if (res.errorCode == this.$msg.responseCode.success) {
            var list=this.buildTree(res.data,0);
            this.alllist=res.data;
            var allData = [
              {
                name: "根目录",
                parentid: "0",
                id: "0",
                children: list
              }
            ];
            
            this.treeData = allData;
            if (this.infos.id) {
              this.getInfo();
            } else {
              this.info.parentid = [0];
            }
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    getParent(id){
      var list=[];
      var parentid=id;
      while(parentid>0){
        for(var i=0;i<this.alllist.length;++i){
          var item=this.alllist[i];
          if(item.id==parentid){
              list.unshift(item.id);
              parentid=item.parentid;
          }
        }
      }
      list.unshift("0");
      return list;
    },
    /**获取详情 */
    getInfo() {
      this.isloading = true;
      this.$api.articlecategory
        .getById(this.infos.id)
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            if (res.data.picture) {
              var picurlArr = res.data.picture.split(",");
              picurlArr.forEach(function(item, index) {
                that.fileList.push({
                  name: item,
                  response: { data: { name: item, path: item } },
                  uid: item,
                  thumbUrl: item
                });
              });
            }
            
            this.info = res.data;
           
            this.info.status = this.$commen.changeIntBoolean(res.data.status);
            this.info.showOnPath = this.$commen.changeIntBoolean(res.data.showOnPath);
            if (res.data.parentid>0){
               this.info.parentid=this.getParent(res.data.parentid);
            }else{
               this.info.parentid = [0];
            }
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleImgChange({ fileList }) {
      this.fileList = fileList;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
         
           this.uploadImg = [];
          this.fileList.forEach(function(item, index) {
            that.uploadImg.push(item.response.data.path);
          });
          if (this.infos.id) {
            //修改
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.articlecategory
              .update(
                this.info.id,
                that.uploadImg.join(","),
                values.name,
                 this.info.parentid[this.info.parentid.length - 1],
                this.info.description,
                values.status
                  ? this.$commen.changeBooleanInt(values.status)
                  : this.$commen.changeBooleanInt(this.info.status),
                values.showOnPath
                  ? this.$commen.changeBooleanInt(values.showOnPath)
                  : this.$commen.changeBooleanInt(this.info.showOnPath),
                  this.info.category,
                  values.linkurl
              )
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          } else {
            //添加
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.articlecategory
              .save(
                values.name,
                that.uploadImg.join(","),
                 this.info.parentid[this.info.parentid.length - 1],
                this.info.description,
                values.status
                  ? this.$commen.changeBooleanInt(values.status)
                  : this.$commen.changeBooleanInt(this.info.status),
                values.showOnPath
                  ? this.$commen.changeBooleanInt(values.showOnPath)
                  : this.$commen.changeBooleanInt(this.info.showOnPath),
                  this.info.category,
                  values.linkurl
               
              )
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          }
        }
      });
    },
    onChange() {
      //console.log(date, dateString);
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    }
  }
};
</script>
<style>
</style>